




















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class CardModalLayout extends Vue {
  @Prop({ required: true })
  readonly value: boolean;
}
